import {Component} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {EndCustomersResource} from '../../model/model-resource';
import {ResourceAutoCompleteComponent} from './resource-auto-complete.component';
import {EndCustomer} from '../../model/end-customer';

@Component({
  selector: 'app-end-customer-auto-complete',
  templateUrl: './resource-auto-complete.component.html',
  styleUrls: ['./resource-auto-complete.component.scss']
})
export class EndCustomerAutoCompleteComponent extends ResourceAutoCompleteComponent<EndCustomer> {
  constructor(builder: UntypedFormBuilder, resource: EndCustomersResource) {
    super(builder, resource);
  }
}
